export const YOUTUBE_PLAY_ISNT_STARTED = -1;
export const YOUTUBE_PLAY_ENDED = 0;
export const YOUTUBE_PLAYING = 1;
export const YOUTUBE_PAUSED = 2;
export const YOUTUBE_BUFFERING = 3;
export const YOUTUBE_IN_QUEUE = 5;
